'use client';

import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  clearSelfOnboardCompletedFlag,
  hasSelfOnboardCompleted,
  readCompletedFirstName,
} from '@/lib/public-routing';

export default function SelfOnboardThankYouPage() {
  const navigate = useNavigate();
  const firstName = readCompletedFirstName();

  useEffect(() => {
    if (!hasSelfOnboardCompleted()) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl p-8 text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto mb-4">
        <i className="ri-check-line text-3xl text-green-600" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
        You&apos;re all set{firstName ? `, ${firstName}` : ''}!
      </h1>
      <p className="text-sm text-slate-500 mb-8">
        Your account has been created. Sign in with your work email and the password you just set.
      </p>
      <Link
        to="/login"
        onClick={() => clearSelfOnboardCompletedFlag()}
        className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-gradient-to-r from-[var(--hrm-primary)] to-[var(--hrm-primary-dark)] text-white font-semibold"
      >
        Go to sign in
      </Link>
    </div>
  );
}
